// Build version marker - updated each release
export const APP_VERSION = 'v0.15.0'
export const BUILD_DATE = '2026-03-06'
